/***
 *
 *   APP LAYOUT STYLES
 *   The shell is a primary-coloured navigation frame with the page sitting
 *   inside it as an inset rounded card. The sidebar lives in the left strip
 *   of that frame (in flow, not `fixed`), so collapsing it lets the card
 *   grow instead of animating a padding reservation.
 *
 *   On mobile the sidebar is hidden and the card keeps a left/top/bottom
 *   inset; the right edge stays flush. The bottom bar sits inside the card
 *   rather than overlaying the frame.
 *
 **********/

const Style = {
    wrapper: 'flex h-screen overflow-hidden bg-primary',

    column: `my-3 ml-3 flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-l-2xl
    bg-background shadow-sm md:ml-0`,

    main: 'flex min-h-0 flex-1 flex-col overflow-y-auto bg-background',
    content: 'py-6',
};

export default Style;
